import {
    Fields,
    FieldStatus,
    fieldStatusStyleMap as styling,
    type Config as IConfig
} from "./types";

export class Config implements IConfig {
    public constructor(
        public readonly fieldStatusStyleMap = styling,
        private readonly fields = {
            [Fields.RequestedChange]: Fields.RequestedChange,
            [Fields.Statuses]: Fields.Statuses,
            [Fields.Comments]: Fields.Comments
        },
        private readonly fieldStatus = {
            [FieldStatus.Approved]: FieldStatus.Approved,
            [FieldStatus.AwaitingReview]: FieldStatus.AwaitingReview,
            [FieldStatus.Rejected]: FieldStatus.Rejected,
            [FieldStatus.RequestedChanges]: FieldStatus.RequestedChanges
        }
    ) {}

    public get FieldsComments() {
        return this.fields[Fields.Comments];
    }

    public get FieldsStatuses() {
        return this.fields[Fields.Statuses];
    }

    public get RequestedChangeFields() {
        return this.fields[Fields.RequestedChange];
    }

    public get FieldStatusRejected() {
        return this.fieldStatus[FieldStatus.Rejected];
    }

    public get FieldStatusApproved() {
        return this.fieldStatus[FieldStatus.Approved];
    }

    public get FieldStatusAwaitingReview() {
        return this.fieldStatus[FieldStatus.AwaitingReview];
    }

    public get FieldStatusRequestedChanges() {
        return this.fieldStatus[FieldStatus.RequestedChanges];
    }
}

export default Config;
